// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file consts/executionconsts.proto (package aurora.core.consts.execution, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file consts/executionconsts.proto.
 */
export const file_consts_executionconsts: GenFile = /*@__PURE__*/
  fileDesc("Chxjb25zdHMvZXhlY3V0aW9uY29uc3RzLnByb3RvEhxhdXJvcmEuY29yZS5jb25zdHMuZXhlY3V0aW9uKkoKD0V4ZWN1dGlvblN0YXR1cxIPCgtVTlNQRUNJRklFRBAAEgsKB01BVENIRUQQARIKCgZCT09LRUQQAhINCglDQU5DRUxMRUQQA0IpWidnaXRsYWIucHJ2YmwuY29tL2F1cm9yYS9jb3JlL3NyYy9jb25zdHNiBnByb3RvMw");

/**
 * @generated from enum aurora.core.consts.execution.ExecutionStatus
 */
export enum ExecutionStatus {
  /**
   * @generated from enum value: UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MATCHED = 1;
   */
  MATCHED = 1,

  /**
   * @generated from enum value: BOOKED = 2;
   */
  BOOKED = 2,

  /**
   * @generated from enum value: CANCELLED = 3;
   */
  CANCELLED = 3,
}

/**
 * Describes the enum aurora.core.consts.execution.ExecutionStatus.
 */
export const ExecutionStatusSchema: GenEnum<ExecutionStatus> = /*@__PURE__*/
  enumDesc(file_consts_executionconsts, 0);

